export enum BuiltInExteriorPropId {
  GARAGEDOORSINGLE = "garageDoorSingle",
  GARAGEDOORSINGLESECONDARY = "garageDoorSingleSecondary",
  GARAGEDOORDOUBLE = "garageDoorDouble",
  GARAGEDOORDOUBLESECONDARY = "garageDoorDoubleSecondary",
  GARAGEDOORDOUBLETERTIARY = "garageDoorDoubleTertiary",
  GARAGEDOORDOUBLEQUATERNARY = "garageDoorDoubleQuaternary",
  DOORGARAGE10080 = "doorGarage10080",
  DOORGARAGE20080 = "doorGarage20080",
  DOORGARAGE18070 = "doorGarage18070",
  DOORGARAGE18070SECONDARY = "doorGarage18070Secondary",
  DOORGARAGE9070 = "doorGarage9070",
  SEDAN = "sedan",
  SUV = "suv",
  TRUCK = "truck",
  DOORSINGLEGLASS32 = "doorSingleGlass32",
  DOORSINGLEGLASS32HL = "doorSingleGlass32HL",
  DOORSINGLEGLASS32LOW = "doorSingleGlass32Low",
  DOORSINGLEGLASS32LOWHL = "doorSingleGlass32LowHL",
  DOORSINGLEGLASS36HL = "doorSingleGlass36HL",
  DOORSINGLEGLASS36LOWHL = "doorSingleGlass36LowHL",
  DOORSINGLEGLASSSECONDARY = "doorSingleGlassSecondary",
  DOORSINGLEGLASSLOWSECONDARY = "doorSingleGlassLowSecondary",
  DOORDOUBLEGLASS = "doorDoubleGlass",
  DOORSLIDINGGLASS4068 = "doorSlidingGlass4068",
  DOORSLIDINGGLASS4080 = "doorSlidingGlass4080",
  DOORSLIDINGGLASS5068 = "doorSlidingGlass5068",
  DOORSLIDINGGLASS5080 = "doorSlidingGlass5080",
  DOORSLIDINGGLASS6068 = "doorSlidingGlass6068",
  DOORSLIDINGGLASS6080 = "doorSlidingGlass6080",
  DOORSLIDINGGLASS7680 = "doorSlidingGlass7680",
  DOORSLIDINGGLASS7880 = "doorSlidingGlass7880",
  DOORSLIDINGGLASS8080 = "doorSlidingGlass8080",
  DOORSLIDINGGLASS9068 = "doorSlidingGlass9068",
  DOORSLIDINGGLASS9080 = "doorSlidingGlass9080",
  DOORSLIDINGGLASS10068 = "doorSlidingGlass10068",
  DOORSLIDINGGLASS10080 = "doorSlidingGlass10080",
  DOORSLIDINGGLASS12080 = "doorSlidingGlass12080",
  DOORSLIDINGGLASS15068 = "doorSlidingGlass15068",
  DOORSLIDINGGLASS15080 = "doorSlidingGlass15080",
  DOORDOUBLEGLASSLOW = "doorDoubleGlassLow",
  DOORDOUBLEGLASS36LOW = "doorDoubleGlass36Low",
  DOORDOUBLEGLASS36LOWHINGEDFIXED = "doorDoubleGlass36LowHingedFixed",
  DOORDOUBLEGLASS36HINGEDFIXED = "doorDoubleGlass36HingedFixed",
  DOORDOUBLESLIDE = "doorDoubleSlide",
  DOORDOUBLESLIDELOW = "doorDoubleSlideLow",
  DOORSINGLEGLASS = "doorSingleGlass",
  DOORSINGLEGLASS36 = "doorSingleGlass36",
  DOORSINGLEGLASSLOW = "doorSingleGlassLow",
  DOORSINGLEGLASSLOWTRANSOM = "doorSingleGlassLowTransom",
  EXTERIORLAMP = "exteriorLamp",
  DECKSET = "deckSet",
  DECKCHAIRSINGLE = "deckChairSingle",
  DECKCHAIR = "deckChair",
  CHAIRADIRONDACK = "chairAdirondack",
  DECKBENCH = "deckBench",
  DECKSIDETABLE = "deckSideTable",
  DECKCOFFEETABLE = "deckCoffeeTable",
  DECKDININGTABLE4SEAT = "deckDiningTable4Seat",
  DECKDININGTABLE6SEAT = "deckDiningTable6Seat",
  GRILLGAS = "grillGas",
  GRILLINSERT = "grillInsert",
  OUTDOORFRIDGE = "outdoorFridge",
  SINK = "sink",
  FIREPIT = "firepit",
  RAKEBRACKET = "rakeBracket",
  ANGLEBRACKET14X18 = "angleBracket14x18",
  ANGLEBRACKET25X27 = "angleBracket25x27",
  ANGLEBRACKET20X20 = "angleBracket20x20",
  SOFFITCORBEL8X12 = "soffitCorbel8x12",
  AWNINGBRACKET = "awningBracket",
  BRACKETFRENCHCOUNTRY = "bracketFrenchCountry",
  BRACKETTALLTAPERED = "bracketTallTapered",
  CEILINGFAN = "ceilingFan",
  CRAFTCOLUMN = "craftColumn",
  CRAFTORNAMENT = "craftOrnament",
  BEAZERORNAMENT = "beazerOrnament",
  SHUTTERS3050 = "shutters3050",
  DOORSINGLEARCH36 = "doorSingleArch36",
  EXTERIORLAMPGAS = "exteriorLampGas",
  ZENCOLUMN = "zenColumn",
  ZENCOLUMNANGLED = "zenColumnAngled",
  CRAFTSHUTTER = "craftShutter",
  ELLIOTTGABLEARCH12 = "elliottGableArch12",
  ELLIOTTGABLEARCH7 = "elliottGableArch7",
  ELLIOTTGABLEARCH8 = "elliottGableArch8",
  ELLIOTTGABLEARCH9 = "elliottGableArch9",
}
